import { render, staticRenderFns } from "./none-food.vue?vue&type=template&id=e43634a4&scoped=true&"
import script from "./none-food.vue?vue&type=script&lang=js&"
export * from "./none-food.vue?vue&type=script&lang=js&"
import style0 from "./none-food.vue?vue&type=style&index=0&id=e43634a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43634a4",
  null
  
)

export default component.exports